/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const SponsorsImg = ({ img }) => <img src={img} alt="sponsor" />;

export default SponsorsImg;
